/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateUserTasksBulkRequest
 */
export interface CreateUserTasksBulkRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUserTasksBulkRequest
     */
    title: string;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof CreateUserTasksBulkRequest
     */
    assigneeUserIds: Array<ApiUserTasksGetPageParameter>;
    /**
     * 
     * @type {string}
     * @memberof CreateUserTasksBulkRequest
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUserTasksBulkRequest
     */
    dueAt?: Date | null;
}

/**
 * Check if a given object implements the CreateUserTasksBulkRequest interface.
 */
export function instanceOfCreateUserTasksBulkRequest(value: object): value is CreateUserTasksBulkRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('assigneeUserIds' in value) || value['assigneeUserIds'] === undefined) return false;
    return true;
}

export function CreateUserTasksBulkRequestFromJSON(json: any): CreateUserTasksBulkRequest {
    return CreateUserTasksBulkRequestFromJSONTyped(json, false);
}

export function CreateUserTasksBulkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserTasksBulkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'assigneeUserIds': ((json['assigneeUserIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'description': json['description'] == null ? undefined : json['description'],
        'dueAt': json['dueAt'] == null ? undefined : (new Date(json['dueAt'])),
    };
}

export function CreateUserTasksBulkRequestToJSON(json: any): CreateUserTasksBulkRequest {
    return CreateUserTasksBulkRequestToJSONTyped(json, false);
}

export function CreateUserTasksBulkRequestToJSONTyped(value?: CreateUserTasksBulkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'assigneeUserIds': ((value['assigneeUserIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'description': value['description'],
        'dueAt': value['dueAt'] == null ? value['dueAt'] : value['dueAt'].toISOString(),
    };
}

